import { useCachedResource } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";
import { shows } from "../local/db";

// Shows the caller's org can see (score-api scopes by the active-org header).
// The announcer picks one on /setup, same as scribe. Cache-first (#640's
// useCachedResource): served from IndexedDB, revalidated from score-api online.
export function useShows(online) {
  const api = useScoreApi();
  return useCachedResource(
    async () => {
      const cached = await shows.getAll();
      return cached.length ? cached : undefined;
    },
    async () => {
      const list = unwrap(await api.shows.listShows());
      await shows.putAll(list);
      return list;
    },
    [api],
    online,
  );
}
